import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=38b9a54c"
import script from "./UserManagement.vue?vue&type=script&lang=ts"
export * from "./UserManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38b9a54c')) {
      api.createRecord('38b9a54c', component.options)
    } else {
      api.reload('38b9a54c', component.options)
    }
    module.hot.accept("./UserManagement.vue?vue&type=template&id=38b9a54c", function () {
      api.rerender('38b9a54c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/admin/UserManagement.vue"
export default component.exports